import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "@/data/faqs";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { getWhatsAppUrl } from "@/lib/whatsapp";
import { trackEvent, EVENTS } from "@/lib/tracking";
import { MessageCircle } from "lucide-react";

export const FAQSection = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-white py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHeading
              chapter="11"
              kicker="FAQ"
              title="Pertanyaan yang Sering Diajukan"
              description="Belum menemukan jawaban? Hubungi kami langsung via WhatsApp."
            />
            <Reveal delay={0.15}>
              <a
                href={getWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent(EVENTS.WHATSAPP_CLICK, { source: "faq" })}
                data-testid="faq-whatsapp-cta"
                className="mt-8 inline-flex items-center gap-2.5 rounded-lg border border-slate-300 px-5 py-3 text-sm font-bold text-slate-900 transition-colors hover:border-[#25D366] hover:text-[#25D366]"
              >
                <MessageCircle className="h-4 w-4" />
                Tanya via WhatsApp
              </a>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((faq) => (
                <AccordionItem
                  key={faq.id}
                  value={faq.id}
                  data-testid={`faq-item-${faq.id}`}
                  className="border-slate-200"
                >
                  <AccordionTrigger className="py-5 text-left text-base font-bold text-slate-900 hover:no-underline sm:text-lg">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-[15px] leading-relaxed text-slate-600">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
